import { render, staticRenderFns } from "./cartoon.vue?vue&type=template&id=6bceb6fa&"
import script from "./cartoon.vue?vue&type=script&lang=js&"
export * from "./cartoon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports